import { render, staticRenderFns } from "./user-imputation.vue?vue&type=template&id=996a99c0&"
import script from "./user-imputation.vue?vue&type=script&lang=ts&"
export * from "./user-imputation.vue?vue&type=script&lang=ts&"
import style0 from "./user-imputation.vue?vue&type=style&index=0&id=996a99c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports